import { BookbaseLogo } from "@/components/BookbaseLogo";

/**
 * Shown instead of the app when settings are missing (see `missingSettings`). Without
 * them every request goes to the wrong place and the app would wait forever. Locally
 * this means there is no .env.local; in a deployed build, the pipeline did not pass
 * the stack outputs.
 */
export function ConfigMissing({ missing }: { missing: string[] }) {
  const local = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-50 p-6">
      <div className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
        <BookbaseLogo size={32} className="mb-4 rounded-lg" alt="Bookbase" />
        <h1 className="text-lg font-semibold text-gray-900">Bookbase ist nicht eingerichtet</h1>
        <p className="mt-2 text-sm text-gray-600">Es fehlen Einstellungen: {missing.join(", ")}.</p>
        {local ? (
          <div className="mt-4 space-y-3 text-sm text-gray-700">
            <p>
              Lokal: <code className="rounded bg-gray-100 px-1">.env.example</code> nach{" "}
              <code className="rounded bg-gray-100 px-1">.env.local</code> kopieren, die Werte eintragen und{" "}
              <code className="rounded bg-gray-100 px-1">npm run dev</code> neu starten.
            </p>
            <p>Ohne Backend geht es mit Testdaten:</p>
            <div className="flex flex-wrap gap-2">
              <a className="rounded-lg bg-gray-900 px-3 py-2 font-medium text-white" href="/dev/mock.html?role=STUDENT">Schüler-App (Testdaten)</a>
              <a className="rounded-lg border border-gray-300 px-3 py-2 font-medium" href="/dev/mock.html?role=ADMIN">Konsole (Testdaten)</a>
            </div>
          </div>
        ) : (
          <p className="mt-4 text-sm text-gray-700">Bitte die Schul-IT informieren.</p>
        )}
      </div>
    </main>
  );
}
